import { Connector } from "./connector";
import { JsonRPCClient } from "./JsonRPCClient";
import { WalletEvent, WalletRPC } from "./WalletAPI";
const MsafeOrigin = 'https://app.m-safe.io';
export class MsafeWallet {
    constructor(connector) {
        this.events = {};
        const onEvent = (type, ...params) => {
            const cbk = this.events[type];
            cbk && cbk(params[0]);
        };
        const entries = [
            WalletEvent.ChangeAccount,
            WalletEvent.ChangeNetwork
        ].map(event => [event, (...params) => onEvent(event, ...params)]);
        const notifiers = Object.fromEntries(entries);
        this.client = new JsonRPCClient(connector, notifiers);
    }
    async connect() {
        return this.client.request(WalletRPC.connect);
    }
    async isConnected() {
        return this.client.request(WalletRPC.isConnected);
    }
    async disconnect() {
        return this.client.request(WalletRPC.disconnect);
    }
    onChangeAccount(cbk) {
        this.events[WalletEvent.ChangeAccount] = cbk;
    }
    onChangeNetwork(cbk) {
        this.events[WalletEvent.ChangeNetwork] = cbk;
    }
    async network() {
        return this.client.request(WalletRPC.network);
    }
    async account() {
        return this.client.request(WalletRPC.account);
    }
    async chainId() {
        return this.client.request(WalletRPC.chainId);
    }
    async signAndSubmit(payload, option) {
        return this.client.request(WalletRPC.signAndSubmit, [payload, option]);
    }
    async signTransaction(payload, option) {
        return this.client.request(WalletRPC.signTransaction, [payload, option]);
    }
    async signMessage(message) {
        return this.client.request(WalletRPC.signMessage, [message]);
    }
    static async new(msafe = MsafeOrigin) {
        const connector = await Connector.connect(window.parent, msafe);
        return new MsafeWallet(connector);
    }
}
//# sourceMappingURL=MsafeWallet.js.map